/**
 * Survey questions for lounge access survey
 * These questions are stored locally to avoid requiring authentication
 */

export interface SurveyQuestion {
  id: number;
  statement: string;
  helperText?: string;
  position: number;
  kind: QuestionKind;
  purpose: QuestionPurpose;
}

/**
 * Question kinds:
 * 1 - Rating 1-10 (star rating)
 * 2 - Yes/No (1-2)
 * 3 - 3 choices (1-3)
 * 4 - 5 choices (1-5)
 * 5 - Text response
 */
export enum QuestionKind {
  RATING = 1,
  YES_NO = 2,
  THREE_CHOICES = 3,
  FIVE_CHOICES = 4,
  TEXT = 5,
}

/**
 * Question purpose:
 * 0 - General survey question
 * 1 - Masseuse-specific rating question
 */
export enum QuestionPurpose {
  GENERAL = 0,
  MASSEUSE_RATING = 1,
}

export const LOUNGE_SURVEY_QUESTIONS: SurveyQuestion[] = [
  {
    id: 1,
    statement: 'Please rate your overall experience with',
    position: 1,
    kind: QuestionKind.RATING,
    purpose: QuestionPurpose.MASSEUSE_RATING,
  },
  {
    id: 2,
    statement:
      'How would you rate your overall experience today at Club Dynasty spa?',
    position: 2,
    kind: QuestionKind.RATING,
    purpose: QuestionPurpose.GENERAL,
  },
  {
    id: 3,
    statement:
      'Did the masseuse meet your expectations on looks and sensuality?',
    position: 3,
    kind: QuestionKind.RATING,
    purpose: QuestionPurpose.GENERAL,
  },
  {
    id: 4,
    statement:
      'How would you rate your interactions with other staff around the spa?',
    position: 4,
    kind: QuestionKind.RATING,
    purpose: QuestionPurpose.GENERAL,
  },
  {
    id: 5,
    statement:
      'Which distance properly represents how far you drive to come to Club Dynasty?',
    position: 5,
    kind: QuestionKind.THREE_CHOICES,
    purpose: QuestionPurpose.GENERAL,
  },
  {
    id: 6,
    statement:
      'If there was a second location in Toronto, would you likely attend Club Dynasty more often?',
    position: 6,
    kind: QuestionKind.YES_NO,
    purpose: QuestionPurpose.GENERAL,
  },
  {
    id: 7,
    statement: 'How likely are you to repeat with the same masseuse again?',
    position: 7,
    kind: QuestionKind.RATING,
    purpose: QuestionPurpose.GENERAL,
  },
  {
    id: 8,
    statement: 'How would you rate the overall cleanliness of the spa?',
    position: 8,
    kind: QuestionKind.RATING,
    purpose: QuestionPurpose.GENERAL,
  },
  {
    id: 9,
    statement: 'Do our prices properly reflect the value delivered?',
    position: 9,
    kind: QuestionKind.RATING,
    purpose: QuestionPurpose.GENERAL,
  },
  {
    id: 10,
    statement:
      'Would you be interested in IV Drip-Hydration therapy if we offered it?',
    helperText:
      "IV drip hydration is a wellness treatment that delivers fluids, vitamins, and nutrients directly into the bloodstream through an intravenous line. It's used to quickly rehydrate the body, boost energy, and support overall health.",
    position: 10,
    kind: QuestionKind.YES_NO,
    purpose: QuestionPurpose.GENERAL,
  }
];

// Distance choices for question kind 3
export const DISTANCE_CHOICES = [
  { value: 1, label: '1-5 KM' },
  { value: 2, label: '6-20 KM' },
  { value: 3, label: 'Over 20 KM' },
] as const;

// Yes/No choices for question kind 2
export const YES_NO_CHOICES = [
  { value: 1, label: 'Yes' },
  { value: 2, label: 'No' },
] as const;
